<template>
  <!-- eslint-disable prefer-standard-components/no-vuetify-inputs -->
  <v-col
    v-if="enabled"
    :cols="cols"
    :lg="lg"
    :md="md"
  >
    <v-row
      v-if="message"
      dense
    >
      <v-col class="labeled-input">
        {{ $bct(message) }}
        <HelpIcon
          :document="helpDocument"
          :on-help-click="openHelpFlyout"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="6">
        <v-text-field
          v-model="hours"
          @update:model-value="combine"
          :density="dense ? 'compact' : undefined"
          label="Hours"
          max="60"
          maxlength="2"
          min="0"
          placeholder="0"
          type="number"
          variant="filled"
          hide-details
          round
          tile
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="minutes"
          @update:model-value="combine"
          :aria-label="$bct('Minutes')"
          :density="dense ? 'compact' : undefined"
          label="Minutes"
          max="59"
          maxlength="2"
          min="0"
          placeholder="0"
          type="number"
          variant="filled"
          hide-details
          round
          tile
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup>
import HelpIcon from '@/shared/components/form/HelpIcon.vue';
import propsToRefs from '@/shared/utils/propsToRefs';
import useLabeledField from '@/shared/composables/useLabeledField';
import useSchematizedField from '@/shared/composables/useSchematizedField';

const $bct = inject('translator');

defineEmits(useLabeledField.emits);

const props = defineProps({
  ...useLabeledField.props,
  ...useSchematizedField.props,
});

const localValue = defineModel({ type: [String, Number] });

const hours = ref(null);
const minutes = ref(null);

const { handleBlur, handleUpdateModelValue } = useLabeledField(
  ...propsToRefs(props, useLabeledField.paramKeys),
);

const { enabled, helpDocument, openHelpFlyout } = useSchematizedField(
  ...propsToRefs(props, useSchematizedField.paramKeys),
);

watch(localValue, split);

onMounted(split);

function combine() {
  const hoursValue = parseInt(hours.value, 10) || 0;
  const minutesInHours = hoursValue * 60;
  const minutesValue = parseInt(minutes.value, 10) || 0;

  const combinedValue = minutesInHours + minutesValue;

  handleUpdateModelValue(combinedValue);
  handleBlur(combinedValue);
}

function split() {
  const totalMinutes = parseInt(localValue.value, 10);

  if (isNaN(totalMinutes)) {
    hours.value = null;
    minutes.value = null;
    return;
  } else {
    hours.value = parseInt(totalMinutes / 60, 10);
    minutes.value = totalMinutes % 60;

    if (minutes.value === 0) minutes.value = null;
  }
}
</script>
